<span class="mat-mdc-button-persistent-ripple mdc-icon-button__ripple"></span>
<ng-content></ng-content>
<span class="mat-focus-indicator"></span>
<span class="mat-mdc-button-touch-target"></span>
